var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{staticClass:"font-size-14 white",attrs:{"clearable":"","dense":"","hide-details":"","open-on-clear":"","outlined":"","prepend-inner-icon":"mdi-factory","items":_vm.organizationItems,"label":_vm.$t('common.organization_one'),"value":_vm.organizationId},on:{"change":function($event){return _vm.$emit('change', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }